/* Dependencies
 ---------------------------------------------------------- */
import { Application } from 'wrapper6'

/* Services
 ---------------------------------------------------------- */

/* Register services
 ---------------------------------------------------------- */

/* Modules
 ---------------------------------------------------------- */
import CalendarModule from '../modules/_calendar'
import NewssliderModule from '../modules/_newsslider'
import BranchSearchModule from './../modules/_branch-search'
import ShareButtons from './../modules/_share-buttons'
import NewsletterModule from '../modules/_newsletter-signup'
import NewsBar from '../modules/_news-bar'
import ObjectFit from '../modules/_object-fit'
import Masonry from '../modules/_masonry'

/* Vendor
 ---------------------------------------------------------- */

/* Setup
 ---------------------------------------------------------- */
let app = window.app = new Application(window.options || {})

/* Register modules
 ---------------------------------------------------------- */
app.use(CalendarModule)
app.use(NewssliderModule)
app.use(BranchSearchModule)
app.use(ShareButtons)
app.use(NewsletterModule)
app.use(NewsBar)
app.use(ObjectFit)
app.use(Masonry)

// import $ from "jquery";
// window.jQuery = window.$ = $;
